/**
 * Quiz section: mounts React Quiz when .template-quiz is present.
 * Handles startQuiz (hero, URL, body class) and add-to-cart on results.
 */
import { mountQuiz } from "../components/Quiz/mount";
const Brave = (window as Window & { Brave?: { startQuiz?: (updateUrl: boolean) => void } }).Brave ?? {} as { startQuiz?: (updateUrl: boolean) => void };
(window as Window & { Brave?: typeof Brave }).Brave = Brave;

const quiz = () => {
  const quizContainer = document.querySelector("#quiz");
  if (!quizContainer) return;


  Brave.startQuiz = function (updateUrl: boolean) {
    (window as Window & { dataLayer?: unknown[] }).dataLayer?.push({ event: "quizStarted" });
    window.scrollTo(0, 0);

    const landing = document.querySelector("#shopify-section-quiz-hero-top");
    if (landing) (landing as HTMLElement).style.display = "none";

    (quizContainer as HTMLElement).style.display = "block";

    document.body?.classList.add("quiz-started");

    if (updateUrl && typeof URLSearchParams !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("start", "1");
      searchParams.delete("finished");
      searchParams.delete("clear");

      // make sure session storage is cleared
      mountQuiz(true);

      history.pushState(null, "", `${window.location.pathname}?${searchParams.toString()} `);
    } else {
      mountQuiz(false);
    }
  };

  const startButton = document.querySelector(".hero-main__btn");

  if (startButton) {
    startButton.addEventListener("click", (e) => {
      e.preventDefault();
      Brave.startQuiz?.(true);
      return false;
    });
  }

  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has("start") || searchParams.has("finished")) {
    Brave.startQuiz?.(false);
  }
};

export default quiz;
